import { render, staticRenderFns } from "./Promociones.vue?vue&type=template&id=8f6f637c"
import script from "./Promociones.vue?vue&type=script&lang=js"
export * from "./Promociones.vue?vue&type=script&lang=js"
import style0 from "./Promociones.vue?vue&type=style&index=0&id=8f6f637c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports